const CartPreview = () => import('./CartPreview')
const Quantity = () => import('./Quantity')
const Order = () => import('./Order')
const Gallery = () => import('./Gallery')
const ProductItem = () => import('./ProductItem')
const AddToCart = () => import('./AddToCart')
const ProductImagesGallery = () => import('./ProductImagesGallery')

export default function install(Vue) {
  Vue.component('product-cart-preview', CartPreview)
  Vue.component('product-quantity', Quantity)
  Vue.component('product-order', Order)
  Vue.component('product-gallery', Gallery)
  Vue.component('product-item', ProductItem)
  Vue.component('product-add-cart', AddToCart)
  Vue.component('product-images-gallery', ProductImagesGallery)
}
